// Suite action types

const suiteActionTypes = {
  SELECT_SUITE: 'SELECT_SUITE',
  CLEAR_SUITE_SELECTED: 'CLEAR_SUITE_SELECTED',
  GET_SUITE_DETAILED_AVAILABILITY_INFO: 'GET_SUITE_DETAILED_AVAILABILITY_INFO',
  GET_SUITE_DETAILED_AVAILABILITY_SUCCESS: 'GET_SUITE_DETAILED_AVAILABILITY_SUCCESS',
  GET_SUITE_DETAILED_AVAILABILITY_ERROR: 'GET_SUITE_DETAILED_AVAILABILITY_ERROR',
  GET_SUITE_DETAILED_AVAILABILITY_RESET: 'GET_SUITE_DETAILED_AVAILABILITY_RESET',
  SET_SUITE_NEW_RATES: 'SET_SUITE_NEW_RATES',
  GTM_SUITE_IMPRESSIONS: 'GTM_SUITE_IMPRESSIONS',
  SET_SUITE_PERSONALIZATION_PACKAGES: 'SET_SUITE_PERSONALIZATION_PACKAGES'
};

export default suiteActionTypes;
